/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable camelcase */
/* eslint-disable no-console */
import React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

const typographyStyledDescription = {
  textAlign: "left",
  overflow: "auto",
  display: "-webkit-box",
  maxHeight: 300,
  WebkitBoxOrient: "vertical",
  marginTop: 1,
  color: "#8C8C8C",
  whiteSpace: "pre-wrap",
};

const typographyStyledTitle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: "1",
  WebkitBoxOrient: "vertical",
};

const cardStyle = {
  card: {
    maxWidth: 500,
    maxHeight: 1000,
    margin: "auto",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.4)",
    borderRadius: "4.44915px",
    background: "#424242",
  },
  cardMedia: {
    // backgroundColor: '#262b32',
    shadow: "none",
    height: { xs: 300, md: 262 },
    objectFit: "contain",
  },
  cardActions: {
    display: "flex",
    justifyContent: "space-between",
    background: "#616161",
  },
};

const GridStyle = {
  overflow: "auto",
  display: "flex",
  paddingLeft: 10,
  paddingRight: 10,
};

function InformationNode(props) {
  const { context, isPortrait } = props; 

  console.log('Information node context', context);

  if(isPortrait) {
    return (
      <Grid
      container
      justifyContent='center'
      alignItems='center'
      spacing={3}
      margin="auto"
      display="flex"
      
      >
        <Grid item md={12}>
          <Card sx={cardStyle.card}>
            { context.img &&
            <CardMedia
              component='img'
              sx={cardStyle.cardMedia}
              src={context.img.src}
              alt='item_image'
            />
            }
            <CardContent>
              {context.title &&
              <Typography
                gutterBottom
                variant='h3'
                component='div'
                color='primary.contrastText'
                sx={typographyStyledTitle}
              >
                {context.title.text}
              </Typography>}
              {context.description &&
              <Typography variant='h5' sx={typographyStyledDescription}>
                {context.description.text}
              </Typography>}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='center'
      spacing={1}
      margin="auto"
      sx={GridStyle}
    >
      <Grid item md={12}>
        { context.title && 
        <Typography align="center" variant='h3' sx={typographyStyledTitle}>
          {context.title.text} 
        </Typography>
        }
      </Grid>
      <Grid item md={12}>
        <Card sx={{ display: 'flex', marginTop: 2 }}>
          { context.img && 
          <CardMedia
            component="img"
            image={context.img.src}
            alt="option image"
            sx={{ width: context.description ? 300 : 800, objectFit: "cover"}}
          />
          }
          { context.description &&
            <Box>
              <CardContent sx={{ flex: '1 0 auto' }}>
                <Typography 
                  variant="h5" 
                  sx={typographyStyledDescription}
                >
                  {context.description.text}
                </Typography>
              </CardContent>
            </Box>
          }
        </Card>
      </Grid>
    </Grid>
  );
}

InformationNode.propTypes = {
  isPortrait: PropTypes.bool,
  context: PropTypes.shape({
    img: PropTypes.shape({
      src: PropTypes.string
    }),
    title: PropTypes.shape({
      text: PropTypes.string
    }),
    description: PropTypes.shape({
      text: PropTypes.string
    })
  }).isRequired,
};

InformationNode.defaultProps = {
  isPortrait: false
}

export default InformationNode;